<template>
  <button class="closeBtn" @click="closeHandler">
    <svg viewBox="0 0 14 14" fill="none">
      <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="#333333"/>
    </svg>
    <span>닫기</span>
  </button>
</template>

<script>
export default {
  props : {
    closeHandler : Function , 
  }
}
</script>

<style lang="scss" scoped>
  .closeBtn {
    font-size: 0; 
    width: 24px; height: 24px; 
    display: flex; 
    justify-content: center; 
    align-items: center; 
    position: absolute; 
    right: 24px; top: 24px; 
    cursor: pointer;
    svg {
      width: 14px; height: 14px; 
    }
  }
</style>